//#region src/entities/error/helpers.ts
function createError(code, detail) {
	return {
		code,
		detail
	};
}
//#endregion
export { createError };

//# sourceMappingURL=helpers.js.map